const Analytics = 'Analytics';

export const FETCH_USER_MAPPINGS_REQUEST = `${Analytics}/FETCH_USER_MAPPINGS_REQUEST`;
export const FETCH_USER_MAPPINGS_RESPONSE = `${Analytics}/FETCH_USER_MAPPINGS_RESPONSE`;
export const FETCH_USER_MAPPINGS_ERROR = `${Analytics}/FETCH_USER_MAPPINGS_ERROR`;
